import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MediaObserver } from '@angular/flex-layout';
import { WeightsTableComponent } from '../weights-table/weights-table.component';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-alert-max-weight',
  templateUrl: './alert-max-weight.component.html',
  styleUrls: ['./alert-max-weight.component.css']
})
export class AlertMaxWeightComponent implements OnInit {

  max_weight: number|any;
  delivryAddress: any;
  isRelay: any;
  relay: any;

  innerHeight: number = window.innerHeight;

  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    private dialogRef: MatDialogRef<AlertMaxWeightComponent>,
    private dialog: MatDialog,
    private media: MediaObserver,
    private tools: ToolsService
  ) {
    this.delivryAddress = data.delivryAddress;
    this.isRelay = data.isRelay;
    this.relay = data.relay;
  }

  ngOnInit() {
    this.getMaxWeigt();
  }

  /**
   * @description Récupération du poids maximum en fonction du mode d'expedition
   * @returns {void}
   */
  getMaxWeigt(): void {

    /**
     * Si l'adresse est un point relais alors on récupère le mode d'expédition associé au pays du relay
     */
    if (this.isRelay && this.relay) {

      const pointOfsale = this.tools.getStor("point_of_sale");

      for (let index = 0; index < pointOfsale.shipping_costs.length; index++) {
        const shippingMode = pointOfsale.shipping_costs[index];

        let gobreak = false;

        if (shippingMode.is_relay > 0) {

          for (let index2 = 0; index2 < shippingMode.countries.length; index2++) {
            const country = shippingMode.countries[index2];

            if (this.relay.Pays === country.code) {
              this.max_weight = shippingMode.costs[shippingMode.costs.length - 1].max_weight;
              gobreak = true;
              break;
            }

          }

          if (gobreak) {
            break;
          }

        }

      }

    }

    /**
     * Si l'adresse est une adresse de livraison standard alors on récupère directement le mode de livraison sur l'adresse
     */
    else {

      this.max_weight = this.delivryAddress.shipping_mode.costs[this.delivryAddress.shipping_mode.costs.length - 1].max_weight;

    }

  }

  /**
   * @description Ferme la dialog
   * @returns {void}
   */
  closeDial(): void {
    this.dialogRef.close();
  }

  /**
   * @description Ouvre la dialog d'information des modes d'expedition
   * @returns {void}
   */
  openWeightTableDial(): void {
    let myConf = new MatDialogConfig();
    myConf.data = { delivryAddress: this.delivryAddress, isRelay: this.isRelay, relay: this.relay }
    myConf.autoFocus = false;
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.minWidth = "350px";
    this.dialog.open(WeightsTableComponent, myConf);
  }

}
